/**
 * The meeting wizard's steps, in order. Kept out of the page so a pop-up can
 * point at one without importing the whole screen.
 */
export const MEETING_STEPS = ['agenda', 'data', 'analysis', 'outputs'] as const

export type MeetingStep = (typeof MEETING_STEPS)[number]

export const STEP_AGENDA = MEETING_STEPS.indexOf('agenda')
export const STEP_DATA = MEETING_STEPS.indexOf('data')
export const STEP_REPORT = MEETING_STEPS.indexOf('analysis')
export const STEP_GENERATE_OUTPUTS = MEETING_STEPS.indexOf('outputs')

/** `?step=` is one-based, so a hand-typed URL reads the way the wizard is numbered. */
export function meetingStepParam(step: MeetingStep): number {
  return MEETING_STEPS.indexOf(step) + 1
}

/** The inverse: a step index, or null when the param is absent or not a step. */
export function parseMeetingStepParam(raw: string | null): number | null {
  if (!raw) return null
  const value = Number(raw)
  if (!Number.isInteger(value) || value < 1 || value > MEETING_STEPS.length) return null
  return value - 1
}
